<template>
  <AdminLayout><UnpaidOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import UnpaidOrdersTable from './UnpaidOrdersTable.vue';

export default {
  name: 'UnpaidOrders',
  components: { AdminLayout, UnpaidOrdersTable },
};
</script>
